import { render, staticRenderFns } from "./grupo-alvo.vue?vue&type=template&id=d1378d98&"
import script from "./grupo-alvo.vue?vue&type=script&lang=js&"
export * from "./grupo-alvo.vue?vue&type=script&lang=js&"
import style0 from "./grupo-alvo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports